<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western4" id="calibre_pb_7"><a id="Intro_1"></a> <span class="c5"><a href="#/tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1.ch.fixed.fc.tidied.stylehacked.xfixed_split_007#ref_TOC">Introduction</a></span></h1>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">I first met Deborah in an online
survival/prepper forum several years ago. I’ll be honest in that,
at first, she drove me nuts. It seemed like she <i class="calibre2">always</i> had
an opinion on just about any topic that was posted, particularly
those that centered on homesteading or living off the grid. After a
while, though, I understood why she felt it necessary to address
these topics again and again.</p>
<p class="western1">She knew what the hell she was talking
about.</p>
<p class="western1">Deborah lived off the grid for several years.
She learned, through trial and error as well as otherwise, what
really worked and what didn’t. Experiential learning often makes
for the longest lasting lessons, the ones that you never
forget.</p>
<p class="western1">Over the years, I came to value Deborah’s
opinion on many subjects, simply because I knew those opinions were
based on hard realities, not simply book learning. Eventually, she,
a couple of other friends, and myself decided to work together on a
website. This was to be a place where we could share our various
experiences, our knowledge, and our skills with the world.</p>
<p class="western1">That site, SurvivalWeekly.com, was also where
the book you’re holding was born. Well, truth be told, it may not
have been born there but that was the nursery where everyone came
to see the new arrival, so to speak. From the very beginning, it
gained a loyal following, a following that grew with each
installment. It quickly got to the point where people were quick to
notice if an installment was late for some reason. As the story
went on, fans were riveted. They clamored to hear more about how
Allexa and the others in Moose Creek were faring under a range of
different emergencies.</p>
<p class="western1">One thing I really appreciate about The
Journal is that it is very much based in reality. We don’t have
characters who are some sort of super-soldier, capable of surviving
eleventy million gunfights with nary a scratch. No, Allexa and her
friends are all too human. They quibble and quarrel. They make
mistakes. They aren’t perfect. They fall in love and they lose
loved ones.</p>
<p class="western1">In other words, they are just like you and
I.</p>
<p class="western1">As you read The Journal and get to know
Allexa, you’re also getting to know Deborah, at least a bit. See,
there’s an awful lot of Deborah in that character. As the saying
goes, “Write what you know.” Well, that’s what Deborah has done
here. Deborah knows prepping. She’s been there, done that. She’s
lived a prepping lifestyle since before the word “prepping” came
into common parlance and for most of that time, she’s done it all
on her own. She knows what has to be done each and every year in
order to make it through. Putting up the food, preparing the cords
of firewood, laying in the necessary supplies in sufficient
quantities, the list goes on and on. All of it while fully
realizing there is a strong likelihood that there may be weeks at a
time when just getting to the barn and back might be an ordeal due
to the winter weather, let alone any sort of traveling.</p>
<p class="western1">That’s not just admirable, it is downright
humbling.</p>
<p class="western1">I’m not going to spoil anything for you by
going into any detail about the events that transpire in The
Journal. Suffice to say, disasters like those described herein are
very possible in the real world. And, just like in The Journal,
crises have a tendency to come in bunches. One leads to another and
so on, sort of like dominoes. As you’ll see, though, with some
forethought and careful planning, life after a major disaster can
be made at least a bit easier.</p>
<p class="western1">And that’s the other thing I love about The
Journal. Throughout the story, Deborah has included quite a bit of
practical information about being prepared for disasters. Watch
yourself, if you aren’t careful, you just might learn a thing or
two.</p>
<p class="western5">-Jim Cobb</p>
<p class="western1">Author of The Prepper’s Complete Book of
Disaster Readiness and Prepper’s Long-Term Survival Guide</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1.ch.fixed.fc.tidied.stylehacked.xfixed_split_008.vue?c94a5318